import * as React from "react";

function SuccessCheckCircleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M8 .952a7 7 0 107 7 7.009 7.009 0 00-7-7zm0 13a6 6 0 116-6 6.007 6.007 0 01-6 6zm3.242-8.679l.758.763-4.837 4.836-2.687-2.686.758-.758 1.929 1.924 4.079-4.079z"
  }));
}

export default SuccessCheckCircleIcon;